import { render, staticRenderFns } from "./EventGroupSoldOut.vue?vue&type=template&id=824002e0&scoped=true&"
import script from "./EventGroupSoldOut.vue?vue&type=script&lang=ts&"
export * from "./EventGroupSoldOut.vue?vue&type=script&lang=ts&"
import style0 from "./EventGroupSoldOut.vue?vue&type=style&index=0&id=824002e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824002e0",
  null
  
)

export default component.exports